import {UnknownStructuredTable} from '../StructuredTableConstants';

export function hasAnyFinalizedRows(
  structuredTable: UnknownStructuredTable,
  start: number,
  end: number
): boolean {
  return structuredTable.rows.slice(start, end + 1).some((row) => row?.isFinalized);
}

export function hasAnyFinalizedRowsInRanges(
  structuredTable: UnknownStructuredTable,
  ranges: Array<[number, number]>
): boolean {
  return ranges.some(([start, end]) => hasAnyFinalizedRows(structuredTable, start, end));
}
